module.exports = __webpack_public_path__ + "img/footer-bg.9b4c3ebb.png";